import { Form, FormGroup, Label, Input, Spinner, Button } from "reactstrap";
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link,useLocation } from "react-router-dom";
import { validZipCode, validate } from "helpers/validations";
import Modal from "react-bootstrap/Modal";
import toastr from "toastr";

import ReCAPTCHA from "react-google-recaptcha";

// Components
import SwitchInp from "Component/SwitchInp/SwitchInp";

// Validation Helpers
import { validateEmail } from "helpers/EmailValidation";

// Store
import { registerUser, getContentPage, uploadFile, postNewCollection } from "store/actions";
import { validatePassword } from "helpers/passwordValidation";
import VerifyEmail from "helpers/VerifyEmail";
import Termscenter from "Pages/Terms/Termscenter";
import Privacycenter from "Pages/Privacypolicy/Privacycenter";
import Serviceagreement from "Pages/serviceAgreement/Serviceagreement";
import Privadoqr from "Pages/Privadosc/Privadoqr";

export default function Museumsubmission() {
  const [isPrivado, setIsPrivado]=useState()
  const location = useLocation()
useEffect(()=>{
  if(location.state && location.state.signUpwithPrivado){

    setIsPrivado(location.state.signUpwithPrivado)
  }
},[location])
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const { settings } = useSelector((state) => state?.Login);
  const { loading } = useSelector((state) => state?.Register);
  const [fieldsError, setfieldsError] = useState();
  const [museumDescription, setmuseumDescription] = useState("");
  const [text, setText] = useState("");
  const maxCharacterCountmuseum = 2500;
  const maxCharacterCount = 60;
  const [isVerified, setIsVerified] = useState(false);
  const [show, setShow] = useState(false);
  const [verifyStatus, setVerifyStatus] = useState(false);
  const [termOfUse, settermOfUse] = useState(false);
  const [privacypolicy, setprivacypolicy] = useState(false);
  const [serviceAgree, setserviceAgree] = useState(false);
  const [OpenPrivado, setOpenPrivado] = useState(false)
  const [Termandcondition, setTermandcondition] = useState({
    tnc: false,
  });
  const [term, setTerm] = useState({
    tcs: false,
  });
  const [privacyPolicy, setPrivacyPolicy] = useState({
    pps: false,
  });
  const [passwordtype, setPasswordType] = useState("password");
  const [passwordtype2, setPasswordType2] = useState("password");
  const pass = () => {
    if (passwordtype === "password") {
      setPasswordType("text")
      return;
    }
    setPasswordType("password")
  }
  const confirmpass = () => {
    if (passwordtype2 === "password") {
      setPasswordType2("text")
      return;
    }
    setPasswordType2("password")
  }

  const [fields, setFields] = useState({
    name: "",
    museumName: "",
    lastname: "",
    jobTitle: "",
    profileImage: "",
    role: "MUSEUM",
    address: "",
    city: "",
    email: "",
    mobileNumber: "",
    password: "",
    confirmpassword: "",
    zipcode: "",
    zipcodeError:false,
    state: "",
    country: "",
    docs_number: "",
    docs_upload: "",
    docs_link: "",
    website: "",
    socialMedia: "",
    description: "",
    refree_referral_code: ""
  });


  const { content } = useSelector((state) => state?.contentpage);

  const getContent = () => {
    return content?.length && content?.find((item) => item?.slug === "platform-as-a-service-agreement")?.content;

  }

  useEffect(() => {
    dispatch(getContentPage());
    if (localStorage.getItem("referral_code")) {

      setFields((prev) => ({ ...prev, [name + "Error"]: false, ["refree_referral_code"]: localStorage.getItem("referral_code") })
      );

    }
  }, []);

  const {
    name,
    nameError,
    lastname,
    lastnameError,
    museumName,
    museumNameError,
    jobTitle,
    jobTitleError,
    address,
    addressError,
    profileImage,
    profileImageError,
    city,
    cityError,
    email,
    emailError,
    mobileNumber,
    mobileNumberError,
    role,
    state,
    stateError,
    password,
    confirmpassword,
    passwordError,
    confirmpasswordError,
    zipcode,
    zipcodeError,
    country,
    countryError,
    docs_number,
    docs_numberError,
    docs_upload,
    docs_uploadError,
    docs_link,
    docs_linkError,
    website,
    // websiteError,
    socialMedia,
    // socialMediaError,
    description,
    descriptionError,
    refree_referral_code


  } = fields;

  // useEffect(() => {
  //   if (Termandcondition.tnc) {
  //     setShow(true);
  //   }
  // }, [Termandcondition.tnc]);

  const onChangeHandler = (e) => {
    e.persist();
    const { value, name } = e.target;
    if ((name === 'address') && (value.length <= maxCharacterCount)) {
      setText(value);
    }
    if ((name === 'description') && (value.length <= maxCharacterCountmuseum)) {
      setmuseumDescription(value);
    }
    setFields((prev) =>
      value !== "" || undefined || null
        ? { ...prev, [name + "Error"]: false, [name]: value }
        : { ...prev, [name + "Error"]: true, [name]: value }
    );

    setfieldsError((prev) => ({ ...prev, StateError: false }));

  };


  const uploadFileSuccess = (name) => (response) => {
    const { _id, link, message } = response.data;
    setFields((prev) => ({ ...prev, profileImage: _id }));
    setfieldsError((prev) => ({ ...prev, mediaError: false }));
    // toastr.success(message);
    onChangeHandler(name)({ target: { value: _id } });
    if (name == "media") setFields((prev) => ({ ...prev, imgType: link }));
  };

  const handleImageChange = (name) => (evt) => {
    const image = evt.target.files;
    const ext = image[0].name.split(".").pop();
    if (
      ext !== "png" &&
      ext !== "jpg" &&
      ext !== "jpeg"

    ) {
      return toastr.error("Only png, jpg extensions allowed");

    }
    if (image[0] && image[0].size >= 1e6 + 24) {
      toastr.error("Please upload a file smaller than 1 MB");
      return false;
    }
    if (image && image[0]) {
      dispatch(uploadFile({ image: image[0] }, uploadFileSuccess("media")));
      setFields((prevState) => ({
        ...prevState,
        imagePreview: URL.createObjectURL(image[0]),
        imageRaw: image[0],
        fileType: evt.target.files[0].type,
        profileImage: image[0],
      }));
    }
  };
  const uploadDocsSuccess = (name) => (response) => {
    const { _id, link, message } = response.data;
    setFields((prev) => ({ ...prev, docs_link: _id }));

    toastr.success("Additional document has been uploaded successfully.");
    onChangeHandler(name)({ target: { value: _id } });
    if (name == "media") setFields((prev) => ({ ...prev, docsType: link }));
  };
  const handleDocsChange = (name) => (evt) => {
    const docs = evt.target.files;
    if (docs.length === 0) {
      return "";
    }
    const ext = docs[0].name.split(".").pop();
    if (
      ext !== "png" &&
      ext !== "jpg" &&
      ext !== "jpeg" &&
      ext !== "pdf"

    ) {
      return toastr.error("Only png, jpg, pdf extensions allowed");
    }

    if (docs && docs[0]) {
      dispatch(uploadFile({ image: docs[0] }, uploadDocsSuccess("media")));
      setFields((prevState) => ({
        ...prevState,
        docs_upload: docs[0].name

      })
      )

    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    let response = validate(fields);
    setFields((prev) => ({ ...prev, ...response }));

    // name: "",
    // role: "USER",
    // address: "",
    // city: "",
    // email: "",
    // mobileNumber: "",
    // password: "",
    // confirmpassword: "",
    // zipcode: "",
    // State: "",
    // country: "",
    //  if (!fields?.profileImage) {
    //   return toastr.error("Image is required");
    // }
    if (!fields?.profileImage) {
      setFields((prev) => ({ ...prev, profileImage: "653a0ed7cc09d1064302c8bf" }));

    }
    if (fields?.museumName.trim() === '') {
      return toastr.error("Museum name is required");
    }
    if (fields?.name.trim() === '') {
      return toastr.error("Contact person name is required");

    }
    if (fields?.jobTitle.trim() === '') {
      return toastr.error("Job title is required");
    }
    if (fields?.mobileNumber.trim() === '') {
      return toastr.error("Phone number is required");
    }

    if (fields?.mobileNumber?.length < 10) {
      return toastr.error("Phone number must be at least 10 numbers");
    }
    if (fields?.email.trim() === '') {
      return toastr.error("Email is required");

    }
    if (!validateEmail(fields?.email)) {
      toastr.error("Email is not valid.");
      return;
    }
    if (fields?.password.trim() === '') {
      return toastr.error("Password is required");
    }
    // if(fields?.password?.length <= 5){
    //   return toastr.error("Password  Required 6 Characters!!");
    // } else {
    if (!validatePassword(fields?.password)) {
      toastr.error("Password should be a minimum of 6 characters, it must include a lower case, upper case and a special character along with a number.");

      return;
    }
    // }
    if (fields?.confirmpassword.trim() === "") {
      return toastr.error("Confirm password is required");
    }

    if (fields?.password !== fields?.confirmpassword) {
      return toastr.error("Confirm password does not match");
    }
    if (fields?.address.trim() === '') {
      return toastr.error("Address is required");
    }
    if (fields?.country.trim() === '') {
      return toastr.error("Country is required");
    }
    if (fields?.state.trim() === '') {
      return toastr.error("State is required");
    }
    if (fields?.city.trim() === '') {
      return toastr.error("City is required");
    }

    if (fields?.docs_number.trim() === '') {
      return toastr.error("Document number is required");
    }
    if (fields?.docs_upload.trim() === '') {
      return toastr.error("Please upload the document");
    }
    if (fields?.zipcode?.length < 1) {
      return toastr.error("Zip code is required");
    }
    if (fields?.zipcode?.length > 9) {
      setFields((p)=> ({...p, zipcodeError:true }))
      return toastr.error("Zip code should not be greater then 9 characters");
    }
    if (!validZipCode(fields?.zipcode)) {
      setFields((p)=> ({...p, zipcodeError:true }))
      return toastr.error("Special characters are not allowed")
    }
    if (fields?.description?.length < 1) {
      return toastr.error("Description is required")
    }
    if (isVerified) {
      setShow(true);
    } else {
      toastr.error("Please verify that you are not a robot.");
    }
  };

  function closedialogBox() {
    setVerifyStatus(false)
    navigate("/login");
  }

  function handleVerify(response) {
    if (response) {
      setIsVerified(true);
    } else {
      setIsVerified(false);
    }
  }

  function termsAndCon() {
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  };

  const finalSubmit = () => {
    if (Termandcondition?.tnc == false) {
      return toastr.error("Please Accept Terms&Condition");
    }
    const Registerdata = {
      name: name?.trim(),
      museumName: museumName?.trim(),
      jobTitle: jobTitle?.trim(),
      lastname: lastname?.trim(),
      role: "MUSEUM",
      address: address?.trim(),
      profileImage,
      city: city?.trim(),
      email,
      username: email,
      mobileNumber,
      password,
      zipcode,
      state: state?.trim(),
      country,
      docs_number,
      docs_upload,
      docs_link,
      website,
      socialMedia,
      description: description?.trim(),
      refree_referral_code
    };

    const callback = (res) => {
      const { message, status } = res;
      if (status === "failure") {
        toastr.error(message);
        setShow(false);

      } else {
        setOpenPrivado(!OpenPrivado)
        const colletctiondata = {
          name: name?.trim() + " collection",
          description: "Explore Artworks",
          status: true,
          email: email,
          image: profileImage
        }
        dispatch(
          postNewCollection(colletctiondata)
        );
        setVerifyStatus(true);
        // toastr.success(message);
        // navigate("/login");
        setShow(false);
        // verify email dialog

      }
    };
    dispatch(registerUser(Registerdata, callback));

  };
  function removeImage() {
    setFields((prevState) => ({
      ...prevState,
      imagePreview: "",
      imageRaw: "",
      fileType: "",
      profileImage: ""
    }));
  }
  function termofService() {
    settermOfUse(true)
  }
  function privacyPolicycont() {
    setprivacypolicy(true)
  }
  function serviceag() {
    setserviceAgree(true)
  }
  function closeTerms() {
    settermOfUse(false)
    setprivacypolicy(false)
    setserviceAgree(false)
  }
  useEffect(() => {
    document.querySelectorAll('textarea').forEach((el) => {
      el.style.height = el.setAttribute('style', 'height: ' + el.scrollHeight + 'px');
      el.classList.add('auto');
      el.addEventListener('input', e => {
        el.style.height = 'auto';
        el.style.height = (el.scrollHeight) + 'px';
      })
    })
  }, [])

    const Privado = () => {
      setOpenPrivado(!OpenPrivado)
    }
  return (
    <>
      <div className="artist-div">
        <Modal className="artist-modal" size="lg" show={show} centered animation={false}>
          <form>
            <div className="term_userdiv ">
              <div className="term-content-container">
                <div
                  dangerouslySetInnerHTML={{
                    __html: getContent()
                      ? getContent()
                      : "Loading...",
                  }}
                />


                <div className="CustomeCheckBox mb-2">
                  <SwitchInp
                    enabled={Termandcondition?.tnc}
                    handleChangeFun={setTermandcondition}
                    name="tnc" id="tnc"
                  /> <label htmlFor="tnc"></label>

                  <span onClick={serviceag} className="link_text mb-0 cursor-pointer" >  I agree platform as a service agreement</span>


                </div>
                <div className="CustomeCheckBox mb-2">
                  <SwitchInp
                    enabled={term?.tcs}
                    handleChangeFun={setTerm}
                    name="tcs" id="tcs"
                  />  <label htmlFor="tcs"></label>
                  <span onClick={termofService} className="link_text mb-0 cursor-pointer" >I agree, terms of service</span>

                </div>

                <div className="CustomeCheckBox mb-2">
                  <SwitchInp
                    enabled={privacyPolicy.pps}
                    handleChangeFun={setPrivacyPolicy}
                    name="pps" id="pps"
                  /> <label htmlFor="pps"></label>
                  <span onClick={privacyPolicycont} className="link_text mb-0 cursor-pointer" >I agree, privacy policy</span>
                </div>
              </div>


              <div className="termsBtn">
                <div className="textscrollmsg mb-3">
                  <div className="scrollIcon">
                    <i class="fa-light fa-angles-down"></i>
                  </div>
                  <p className="mb-0">Please scroll below  to check all agreement before accepting</p>
                </div>
                <Button
                  variant="danger"
                  className="cancel_btn"
                  onClick={handleClose}
                >
                  Close
                </Button>
                <Button
                  variant="secondary"
                  className="success_btn"
                  onClick={finalSubmit}
                  disabled={!Termandcondition?.tnc || !term?.tcs || !privacyPolicy?.pps}
                >
                  Accept
                </Button>
              </div>
            </div>
          </form>
        </Modal>
      </div>
      <Modal className="termandCoDialog" show={serviceAgree} centered animation={false}>
        <div className="text-end">
          <button onClick={closeTerms} className="btn cancelbtn end-0 top-0"><img src="/images/svg/closeIconDialog.svg" alt="" /></button>
        </div>
        <div className="contentBoxdialog">
          <Serviceagreement />
          {content && <button className="btn btn-primary px-5 btn-sm py-2" onClick={closeTerms}>Back</button>}
        </div>

      </Modal>
      <Modal className="termandCoDialog" show={termOfUse} centered animation={false}>
        <div className="text-end">
          <button onClick={closeTerms} className="btn cancelbtn end-0 top-0"><img src="/images/svg/closeIconDialog.svg" alt="" /></button>
        </div>
        <div className="contentBoxdialog">
          <Termscenter />
          {content && <button className="btn btn-primary px-5 btn-sm py-2" onClick={closeTerms}>Back</button>}
        </div>

      </Modal>
      <Modal className="termandCoDialog" show={privacypolicy} centered animation={false}>
        <div className="text-end">
          <button onClick={closeTerms} className="btn cancelbtn end-0 top-0"><img src="/images/svg/closeIconDialog.svg" alt="" /></button>
        </div>
        <div className="contentBoxdialog">
          <Privacycenter />
          {content && <button className="btn btn-primary px-5 btn-sm py-2" onClick={closeTerms}>Back</button>}
        </div>
      </Modal>
      <Modal className="EmailVerifyBoxModel text-center" size="md" show={verifyStatus} centered animation={false}>
        <VerifyEmail />
        <button className="btn btn-primary btn-sm py-2 text-white" onClick={closedialogBox}>Close</button>
      </Modal>

      <section className="container-fluid authMaine">
        <div className="row h-100">
          <Col lg="7" className="authLeft userLogin">
            <img src="../../images/svg/museumBg.svg" className="Loginim" alt="Login" />
          </Col>
          <Col lg="5" className="authRight">
            <div className="loginInner py-5">
              <div className="logobx">
                {/* <button className="btn border-0"><i className="fa-sharp fa-light fa-arrow-left-long"></i> Back</button> */}
                <a href="https://terpnash.com/" rel="noreferrer" className="navbar-brand mx-auto py-0">
                  {settings?.logo?.link && (
                    <div className="d-flex align-items-center justify-content-start position-relative gap-3">
                      <>
                        {settings?.logo?.link.search(".mp4") !== -1 ? (

                          <img
                            src={settings?.logo?.link || "/images/t3.gif"}
                            // src={"/images/t3.gif"}
                            alt="logo"
                          />
                        ) : (
                          <img
                            alt="logo"
                            className="img-fluid logodesktop"
                            src={settings?.logo?.link || "/images/t3.gif"}
                          // src={"/images/t3.gif"}
                          />
                        )}
                      </>

                      {/* <a href="https://terpnash.com/" rel="noreferrer" className="nav-link loginLogo logohead ">
                        Terpnash
                      </a> */}
                    </div>
                  )}
                </a>
              </div>
              <div className="AuthUserTabs mt-4">
                {/* <Link className="tabs " to='/users/register'>User</Link>
                <Link className="tabs active" to='/museums/register'>Museum</Link>
                <Link className="tabs" to='/artist/register'>Artist</Link> */}


               <Link className="tabs"  to= '/users/register'  state={{ signUpwithPrivado: isPrivado }}>User</Link>
               <Link className="tabs active" to='/museums/register' state={{ signUpwithPrivado: isPrivado }}>Museum</Link>
               <Link className="tabs" to='/artist/register' state={{ signUpwithPrivado: isPrivado }}>Artist</Link>
              </div>
              <div className="artist-submission create-nftform text-start mt-5">
                <h1> Museum Registration</h1>
                {/* <p> Registering for Terpnash will low you to purchase and sale NFT's on our site. </p> */}
                <Form className="registration-here">
                  <Row>
                    <Col lg={12}>
                      <div className="fileupload-wrap mt-2">
                        <div className="upload-btn-wrapper">
                          {fields?.imagePreview ? (
                            <div className="upload-image position-relative text-center">
                              <div className="profilephotoClose" onClick={removeImage}><i className="fa-regular fa-xmark"></i></div>
                              <label htmlFor="inputGroupFile01">
                                <div className="fileContainer sprite">
                                  <img
                                    className="img-fluid"
                                    src={
                                      fields?.imagePreview || "img/upload-img.png"
                                    }
                                    alt=""
                                  />
                                </div>
                              </label>
                              <input
                                className="previewImageInput"
                                name="profileImage"
                                type="file"
                                id="inputGroupFile01"
                                onChange={handleImageChange("profileImage")}
                                accept="image/*"
                              />
                            </div>
                          ) : (
                            <>
                              <label className={"btnwrap"} htmlFor="inputGroupFile01">
                                <i className="fa-regular fa-arrow-up-from-bracket"></i> <br />
                                Upload Profile Picture  <br /> file size : 1MB.
                              </label>
                              <input
                                name="image"
                                type="file"
                                id="inputGroupFile01"
                                onChange={handleImageChange("image")}
                                accept="image/*"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col lg={12} >
                      <FormGroup className="form-group position-relative">
                        <Input
                          type="text"
                          placeholder="Museum Name"
                          name="museumName"
                          id="museumName"
                          value={museumName}
                          invalid={museumNameError}
                          required={museumNameError}
                          onChange={onChangeHandler}
                          maxLength={30}
                        />
                        {/* <Label for="name">Full Name <span className="col-red">*</span></Label> */}
                      </FormGroup>
                    </Col>
                    <Col lg={6} >
                      <FormGroup className="form-group position-relative">
                        <Input
                          type="text"
                          placeholder="Contact Person Name"
                          name="name"
                          id="name"
                          value={name}
                          invalid={nameError}
                          required={nameError}
                          onChange={onChangeHandler}
                          maxLength={30}
                        />
                        {/* <Label for="name">Full Name <span className="col-red">*</span></Label> */}
                      </FormGroup>
                    </Col>
                    <Col lg={6}>
                      <FormGroup className="form-group position-relative">
                        {/* <Label>
                      Last Name <span className="col-red">*</span>
                    </Label> */}
                        <Input
                          type="text"
                          placeholder="Job title"
                          name="jobTitle"
                          value={jobTitle}
                          invalid={jobTitleError}
                          required={jobTitleError}
                          onChange={onChangeHandler}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <FormGroup className="form-group  position-relative">
                        {/* <Label>
                      Phone <span className="col-red">*</span>
                    </Label> */}
                        <Input
                          type="number"
                          maxlength="11" placeholder="Phone Number"
                          min="1"
                          name="mobileNumber"
                          value={mobileNumber}
                          invalid={mobileNumberError}
                          required={mobileNumberError}
                          onChange={onChangeHandler}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <FormGroup className="form-group  position-relative">
                        {/* <Label>
                      E-mail <span className="col-red">*</span>
                    </Label> */}
                        <Input
                          pattern={
                            fields?.email == ".+@gmail.com" ||
                            fields?.email == ".com"
                          }
                          placeholder='Email'
                          type="email"
                          name="email"
                          value={email}
                          invalid={emailError}
                          required={emailError}
                          onChange={onChangeHandler}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <FormGroup className=" form-group  position-relative">
                        {/* <Label>
                      Password <span className="col-red">*</span>
                    </Label> */}
                        <Input placeholder="Password"
                          type={passwordtype} className="pe-5"
                          name="password"

                          value={password}
                          invalid={passwordError}
                          required={passwordError}
                          onChange={onChangeHandler}
                        />
                        <button type="button" onClick={pass} className="btn position-absolute top-0 end-0 bottom-0 my-auto border-0 inpicon">
                          {passwordtype === 'password' ? <i className="fa-light fa-eye-slash"></i> : <i className="fa-light fa-eye"></i>}
                        </button>
                      </FormGroup>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <FormGroup className=" form-group  position-relative">
                        {/* <Label>
                      Password <span className="col-red">*</span>
                    </Label> */}
                        <Input placeholder="Confirm Password"
                          type={passwordtype2} className="pe-5"
                          name="confirmpassword"

                          value={confirmpassword}
                          invalid={confirmpasswordError}
                          required={confirmpasswordError}
                          onChange={onChangeHandler}
                        />
                        <button type="button" onClick={confirmpass} className="btn position-absolute top-0 end-0 bottom-0 my-auto border-0 inpicon">
                          {passwordtype2 === 'password' ? <i className="fa-light fa-eye-slash"></i> : <i className="fa-light fa-eye"></i>}
                        </button>
                      </FormGroup>
                    </Col>
                    <Col lg={12} >
                      <FormGroup className=" form-group position-relative">
                        {/* <Label>
                      Address <span className="col-red">*</span>
                    </Label> */}
                        <Input type="textarea"
                          maxLength={60}
                          value={address} placeholder="Address"
                          invalid={addressError} name="address"
                          required={addressError}
                          onChange={onChangeHandler}
                        />

                        <div className="addresmsg position-absolute bottom-0 end-0">
                          {maxCharacterCount - text.length}/
                          {maxCharacterCount}
                        </div>
                      </FormGroup>
                    </Col>
                    <Col lg={12}>
                      <FormGroup className="form-group  position-relative">

                        <Input
                          type="select"
                          name="country" placeholder="Country"
                          value={country} className="form-control"
                          invalid={countryError}
                          required
                          // required={countryError}
                          onChange={onChangeHandler}
                        >
                          <option value="" disabled selected>Country</option>
                          <option value="Afghanistan">Afghanistan</option>
                          <option value="Albania">Albania</option>
                          <option value="Algeria">Algeria</option>
                          <option value="American Samoa">American Samoa</option>
                          <option value="Andorra">Andorra</option>
                          <option value="Angola">Angola</option>
                          <option value="Anguilla">Anguilla</option>
                          <option value="Antigua">Antigua</option>
                          <option value="Argentina">Argentina</option>
                          <option value="Armenia">Armenia</option>
                          <option value="Aruba">Aruba</option>
                          <option value="Australia">Australia</option>
                          <option value="Austria">Austria</option>
                          <option value="Azerbaijan">Azerbaijan</option>
                          <option value="Bahrain">Bahrain</option>
                          <option value="Bangladesh">Bangladesh</option>
                          <option value="Barbados">Barbados</option>

                          <option value="Burkina Faso">Burkina Faso</option>
                          <option value="Brazil">Brazil</option>
                          <option value="Belarus">Belarus</option>
                          <option value="Brazil">Brazil</option>
                          <option value="Belarus">Belarus</option>
                          <option value="Belgium">Belgium</option>
                          <option value="Belize">Belize</option>
                          <option value="Benin">Benin</option>
                          <option value="Bermuda">Bermuda</option>
                          <option value="Bhutan">Bhutan</option>
                          <option value="Bolivia">Bolivia</option>
                          <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                          <option value="Botswana">Botswana</option>
                          <option value="Bulgaria">Bulgaria</option>
                          <option value="Burundi">Burundi</option>

                          <option value="Bonaire, Sint Eustatius and Saba">Bonaire, Sint Eustatius and Saba</option>
                          <option value="British Virgin Islands">British Virgin Islands</option>
                          <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                          <option value="Brunei">Brunei</option>

                          <option value="Côte d'Ivoire">Côte d'Ivoire</option>
                          <option value="Central African Republic">Central African Republic</option>
                          <option value="China">China</option>
                          <option value="Chad">Chad</option>
                          <option value="Chile">Chile</option>
                          <option value="Curaçao">Curaçao</option>
                          <option value="Croatia">Croatia</option>
                          <option value="Cape Verde">Cape Verde</option>
                          <option value="Colombia">Colombia</option>
                          <option value="Costa Rica">Costa Rica</option>
                          <option value="Cuba">Cuba</option>
                          <option value="Canada">Canada</option>
                          <option value="Cambodia">Cambodia</option>
                          <option value="Cook Islands">Cook Islands</option>
                          <option value="Czech Republic">Czech Republic</option>
                          <option value="Cayman Islands">Cayman Islands</option>
                          <option value="Comoros">Comoros</option>
                          <option value="Cyprus">Cyprus</option>
                          <option value="Denmark">Denmark</option>
                          <option value="Djibouti">Djibouti</option>
                          <option value="Dominican Republic">Dominican Republic</option>
                          <option value="Dominica">Dominica</option>
                          <option value="Democratic Republic of the Congo">Democratic Republic of the Congo</option>
                          <option value="Egypt">Egypt</option>
                          <option value="Ethiopia">Ethiopia</option>
                          <option value="Estonia">Estonia</option>
                          <option value="Ecuador">Ecuador</option>
                          <option value="El Salvador">El Salvador</option>
                          <option value="Eritrea">Eritrea</option>
                          <option value="Equatorial Guinea">Equatorial Guinea</option>
                          <option value="France">France</option>
                          <option value="French Guiana">French Guiana</option>
                          <option value="French Polynesia">French Polynesia</option>
                          <option value="Fiji">Fiji</option>
                          <option value="Finland">Finland</option>
                          <option value="Falkland Islands">Falkland Islands</option>
                          <option value="Faroe Islands">Faroe Islands</option>
                          <option value="Federated States of Micronesia">Federated States of Micronesia</option>
                          <option value="Georgia">Georgia</option>
                          <option value="Grenada">Grenada</option>
                          <option value="Greenland">Greenland</option>
                          <option value="Guadeloupe">Guadeloupe</option>
                          <option value="Guam">Guam</option>
                          <option value="Guernsey">Guernsey</option>
                          <option value="Guyana">Guyana</option>
                          <option value="Ghana">Ghana</option>
                          <option value="Guinea">Guinea</option>
                          <option value="Gabon">Gabon</option>
                          <option value="Guatemala">Guatemala</option>
                          <option value="Greece">Greece</option>
                          <option value="Gibraltar">Gibraltar</option>
                          <option value="Guinea-Bissau">Guinea-Bissau</option>
                          <option value="Haiti">Haiti</option>
                          <option value="Honduras">Honduras</option>
                          <option value="Hong Kong">Hong Kong</option>
                          <option value="Hungary">Hungary</option>
                          <option value="Iceland">Iceland</option>
                          <option value="Isle Of Man">Isle Of Man</option>
                          <option value="Iran">Iran</option>
                          <option value="Italy">Italy</option>
                          <option value="Iraq">Iraq</option>
                          <option value="India">India</option>
                          <option value="Israel">Israel</option>
                          <option value="Indonesia">Indonesia</option>
                          <option value="Ireland">Ireland</option>
                          <option value="Jordan">Jordan</option>
                          <option value="Jamaica">Jamaica</option>
                          <option value="Jersey">Jersey</option>
                          <option value="Japan">Japan</option>
                          <option value="Kenya">Kenya</option>
                          <option value="Kiribati">Kiribati</option>
                          <option value="Kazakhstan">Kazakhstan</option>
                          <option value="Kyrgyzstan">Kyrgyzstan</option>
                          <option value="Kuwait">Kuwait</option>
                          <option value="Kosovo">Kosovo</option>
                          <option value="Lithuania">Lithuania</option>
                          <option value="Liberia">Liberia</option>
                          <option value="Libya">Libya</option>
                          <option value="Latvia">Latvia</option>
                          <option value="Lesotho">Lesotho</option>
                          <option value="Laos">Laos</option>
                          <option value="Lebanon">Lebanon</option>
                          <option value="Liechtenstein">Liechtenstein</option>
                          <option value="Luxembourg">Luxembourg</option>
                          <option value="Macau">Macau</option>
                          <option value="Maldives">Maldives</option>
                          <option value="Malta">Malta</option>
                          <option value="Malawi">Malawi</option>
                          <option value="Malaysia">Malaysia</option>
                          <option value="Montenegro">Montenegro</option>
                          <option value="Mali">Mali</option>
                          <option value="Macedonia">Macedonia</option>
                          <option value="Marshall Islands">Marshall Islands</option>
                          <option value="Martinique">Martinique</option>
                          <option value="Mayotte">Mayotte</option>
                          <option value="Mauritius">Mauritius</option>
                          <option value="Mauritania">Mauritania</option>
                          <option value="Mongolia">Mongolia</option>
                          <option value="Montserrat">Montserrat</option>
                          <option value="Myanmar">Myanmar</option>
                          <option value="Moldova">Moldova</option>
                          <option value="Morocco">Morocco</option>
                          <option value="Monaco">Monaco</option>
                          <option value="Mexico">Mexico</option>
                          <option value="Mozambique">Mozambique</option>
                          <option value="Madagascar">Madagascar</option>
                          <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                          <option value="North Korea">North Korea</option>
                          <option value="New Zealand">New Zealand</option>
                          <option value="New Caledonia">New Caledonia</option>
                          <option value="Norway">Norway</option>
                          <option value="Nauru">Nauru</option>
                          <option value="Namibia">Namibia</option>
                          <option value="Nepal">Nepal</option>
                          <option value="Nicaragua">Nicaragua</option>
                          <option value="Niger">Niger</option>
                          <option value="Norfolk Island">Norfolk Island</option>
                          <option value="Netherlands">Netherlands</option>
                          <option value="Nigeria">Nigeria</option>
                          <option value="Niue">Niue</option>
                          <option value="Oman">Oman</option>
                          <option value="Portugal">Portugal</option>
                          <option value="Peru">Peru</option>
                          <option value="Palau">Palau</option>
                          <option value="Poland">Poland</option>
                          <option value="Paraguay">Paraguay</option>
                          <option value="Pakistan">Pakistan</option>
                          <option value="Panama">Panama</option>
                          <option value="Philippines">Philippines</option>
                          <option value="Palestine">Palestine</option>
                          <option value="Puerto Rico">Puerto Rico</option>
                          <option value="Papua New Guinea">Papua New Guinea</option>
                          <option value="Qatar">Qatar</option>
                          <option value="Republic of the Congo">Republic of the Congo</option>
                          <option value="Russia">Russia</option>
                          <option value="Réunion">Réunion</option>
                          <option value="Rwanda">Rwanda</option>
                          <option value="Romania">Romania</option>
                          <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                          <option value="Saint Helena">Saint Helena</option>
                          <option value="Saint Martin">Saint Martin</option>
                          <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                          <option value="Sint Maarten">Sint Maarten</option>
                          <option value="San Marino">San Marino</option>
                          <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                          <option value="Sri Lanka">Sri Lanka</option>
                          <option value="Slovakia">Slovakia</option>
                          <option value="Slovenia">Slovenia</option>
                          <option value="Sudan">Sudan</option>
                          <option value="Swaziland">Swaziland</option>
                          <option value="Sweden">Sweden</option>
                          <option value="Switzerland">Switzerland</option>
                          <option value="South Africa">South Africa</option>
                          <option value="South Sudan">South Sudan</option>
                          <option value="Samoa">Samoa</option>
                          <option value="Serbia">Serbia</option>
                          <option value="Sierra Leone">Sierra Leone</option>
                          <option value="Senegal">Senegal</option>
                          <option value="Seychelles">Seychelles</option>
                          <option value="Saudi Arabia">Saudi Arabia</option>
                          <option value="Saint Barthélemy">Saint Barthélemy</option>
                          <option value="Suriname">Suriname</option>
                          <option value="Solomon Islands">Solomon Islands</option>
                          <option value="Somalia">Somalia</option>
                          <option value="Saint Lucia">Saint Lucia</option>
                          <option value="South Korea">South Korea</option>
                          <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                          <option value="Singapore">Singapore</option>
                          <option value="Syria">Syria</option>
                          <option value="Spain">Spain</option>
                          <option value="The Bahamas">The Bahamas</option>
                          <option value="The Gambia">The Gambia</option>
                          <option value="Timor-Leste">Timor-Leste</option>
                          <option value="Taiwan">Taiwan</option>
                          <option value="Tajikistan">Tajikistan</option>
                          <option value="Thailand">Thailand</option>
                          <option value="Tonga">Tonga</option>
                          <option value="Tanzania">Tanzania</option>
                          <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                          <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                          <option value="Tunisia">Tunisia</option>
                          <option value="Tuvalu">Tuvalu</option>
                          <option value="Turkey">Turkey</option>
                          <option value="Tokelau">Tokelau</option>
                          <option value="Turkmenistan">Turkmenistan</option>
                          <option value="Togo">Togo</option>
                          <option value="Uganda">Uganda</option>
                          <option value="Ukraine">Ukraine</option>
                          <option value="United Arab Emirates">United Arab Emirates</option>
                          <option value="United Kingdom">United Kingdom</option>
                          <option value="United States">United States</option>
                          <option value="Uruguay">Uruguay</option>
                          <option value="Uzbekistan">Uzbekistan</option>
                          <option value="Vatican City">Vatican City</option>
                          <option value="Venezuela">Venezuela</option>
                          <option value="Vanuatu">Vanuatu</option>
                          <option value="Vietnam">Vietnam</option>
                          <option value="Wallis and Futuna">Wallis and Futuna</option>
                          <option value="Western Sahara">Western Sahara</option>
                          <option value="Yemen">Yemen</option>
                          <option value="Zambia">Zambia</option>
                          <option value="Zimbabwe">Zimbabwe</option>

                        </Input>
                      </FormGroup>
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                      <FormGroup className="form-group  position-relative">
                        {/* <Label>
                      State <span className="col-red">*</span>
                    </Label> */}
                        <Input
                          type="text"
                          name="state" placeholder="State"
                          value={state}
                          invalid={stateError}
                          required={stateError}
                          onChange={onChangeHandler}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                      <FormGroup className="form-group  position-relative">
                        {/* <Label>
                      City <span className="col-red">*</span>
                    </Label> */}
                        <Input
                          type="text"
                          name="city" placeholder="City"
                          value={city}
                          invalid={cityError}
                          required={cityError}
                          onChange={onChangeHandler}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                      <FormGroup className="form-group  position-relative">
                        {/* <Label>
                      Zip <span className="col-red">*</span>
                    </Label> */}
                        <Input
                          type="text"
                          name="zipcode" placeholder="Zip"
                          maxLength={9}
                          value={zipcode}
                          invalid={zipcodeError}
                          required={zipcodeError}
                          onChange={onChangeHandler}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg={6}>
                      <FormGroup className="form-group position-relative">
                        {/* <Label>
                      Last Name <span className="col-red">*</span>
                    </Label> */}
                        <Input
                          type="text"
                          placeholder="Document Number"
                          name="docs_number"
                          value={docs_number}
                          invalid={docs_numberError}
                          required={docs_numberError}
                          onChange={onChangeHandler}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg={6} >
                      <FormGroup className="form-group position-relative">
                        <Input
                          type="text"
                          placeholder="Upload Document"
                          name="docs_upload"
                          id="docs_upload" className="pe-5"
                          value={docs_upload}
                          invalid={docs_uploadError}
                          required={docs_uploadError}
                          onChange={onChangeHandler}
                          disabled
                        />
                        <Input className="d-none"
                          type="file"
                          name="docs_link"
                          id="docs_link"
                          invalid={docs_linkError}
                          required={docs_linkError}
                          onChange={handleDocsChange('docs_link')}
                        // accept="image/*"

                        />
                        <label className="btn position-absolute end-0 top-0 bottom-0 border-0 inpicon" htmlFor="docs_link"><i className="fa-light fa-arrow-up-from-bracket text-danger"></i></label>

                      </FormGroup>
                    </Col>

                    <Col lg={12} >
                      <FormGroup className="form-group position-relative">
                        <Input
                          type="text"
                          placeholder="Website(Optional)"
                          name="website"
                          id="website"
                          value={website}
                          // invalid={websiteError}
                          // required={websiteError}
                          onChange={onChangeHandler}
                        />
                        {/* <Label for="name">Full Name <span className="col-red">*</span></Label> */}
                      </FormGroup>
                    </Col>
                    {/* <Col lg={12} >
                      <FormGroup className="form-group position-relative">
                        <Input
                          type="text"
                          placeholder="Social Media Links(Optional)"
                          name="socialMedia"
                          id="socialMedia"
                          value={socialMedia}
                          // invalid={socialMediaError}
                          // required={socialMediaError}
                          onChange={onChangeHandler}
                        />
                       <Label for="name">Full Name <span className="col-red">*</span></Label> 
                      </FormGroup>
                    </Col> */}
                    <Col lg={12} >
                      <FormGroup className="form-group position-relative ">
                        <Input type="textarea"
                          maxLength={2500}
                          placeholder="Description / Biography"
                          name="description" className="pb-4"
                          id="description"
                          value={description}
                          invalid={descriptionError}
                          required={descriptionError}
                          onChange={onChangeHandler}
                        />
                        <div className="addresmsg position-absolute bottom-0 end-0">
                          {maxCharacterCountmuseum - museumDescription.length}/
                          {maxCharacterCountmuseum}
                        </div>
                        {/* <Label for="name">Full Name <span className="col-red">*</span></Label> */}
                      </FormGroup>
                    </Col>
                    <Col lg={12} md={12} sm={12}>

                      <FormGroup className="form-group  position-relative">
                        {/* <Label className="optionInputText">
                          Optional
                        </Label> */}
                        <Input
                          type="text"
                          name="refree_referral_code" placeholder="Referral code "
                          // maxLength={9}
                          value={fields?.refree_referral_code}
                          // invalid={zipcodeError}
                          // required={zipcodeError}
                          onChange={onChangeHandler}
                        />
                      </FormGroup>
                    </Col>

                    {/* <Col lg={12}>
                  <FormGroup className=" form-group  position-relative">
                    <div className="CustomeCheckBox">
                       <Input type="checkbox"  id="terms" />  
                      <label for="terms"></label>  *
                      <div><span className="cursor-pointer link_text" onClick={termsAndCon}>I agree Platform as a Service Agreement</span></div>
                    </div>
                  </FormGroup>
                </Col> */}
                    <ReCAPTCHA
                      sitekey={
                        settings?.googleCaptchaKey?.captchaKey ||
                        "6LfHhHgmAAAAAMDY7S-sxLljqfIE6ku1u1zYWNi2"
                      }
                      onChange={(e) => handleVerify(e)}
                    />
                  </Row>
                  <div className="text-center Done-wrap">
                    <button
                      onClick={onSubmit}
                      className={isPrivado === "privado" ? "btn btn-primary w-100 prevadobtnnew" : "btn btn-primary w-100 "}
                      type="submit"
                    // disabled={Termandcondition?.tnc == false}
                    >
                      Create Account {loading ? (<Spinner animation="border" size="sm" role="status"></Spinner>) : ('')}
                    </button>
                  </div>

                  <div className="creetea-account text-center signupbottomText">
                    <p className="text-light2 fw-medium">
                      <span className="text-new_user "> Already have an account?  <Link to="/login"><span className="text-black fw-bold">Login</span></Link></span>
                    </p>
                  </div>

                  {/* {loading ? (
                <div className="loading_div">
                  <button className="loading_btn" type="submit">
                    <Spinner animation="border" role="status"></Spinner>
                  </button>
                </div>
              ) : (
                
              )} */}
                </Form>
              </div>

            </div>
          </Col>
        </div>
      </section>

      {/* <section className="fine-registration" hidden>
        <Container>
          <div className="DigitalArtcollection-head text-center">
            <h2> Terpnash Registration</h2>
            <p>
              Registering for Terpnash will allow you to purchase and sale NFT's
              on our site.
            </p>
          </div>

          <div className="registration-form">
            <Form className="registration-here">
              <Row>
                <Col lg={12}>
                  <FormGroup className="position-relative">
                    <Label>
                      Full Name <span className="col-red">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="name"
                      value={name}
                      invalid={nameError}
                      required={nameError}
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg={12}>
                  <FormGroup className="position-relative">
                    <Label>
                      Address <span className="col-red">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="address"
                      value={address}
                      invalid={addressError}
                      required={addressError}
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg={3} md={6} sm={12}>
                  <FormGroup className="position-relative">
                    <Label>
                      Zip <span className="col-red">*</span>
                    </Label>
                    <Input
                      type="number"
                      name="zipcode"
                      min="1"
                      value={zipcode}
                      invalid={zipcodeError}
                      required={zipcodeError}
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg={3} md={6} sm={12}>
                  <FormGroup className="position-relative">
                    <Label>
                      City <span className="col-red">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="city"
                      value={city}
                      invalid={cityError}
                      required={cityError}
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg={3} md={6} sm={12}>
                  <FormGroup className="position-relative">
                    <Label>
                      State <span className="col-red">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="State"
                      value={state}
                      invalid={stateError}
                      required={stateError}
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg={3} md={6} sm={12}>
                  <FormGroup className="position-relative">
                    <Label>
                      Country <span className="col-red">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="country"
                      value={country}
                      invalid={countryError}
                      required={countryError}
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg={6} md={12} sm={12}>
                  <FormGroup className="position-relative">
                    <Label>
                      Phone <span className="col-red">*</span>
                    </Label>
                    <Input
                      type="number"
                      maxlength="11"
                      min="1"
                      name="mobileNumber"
                      value={mobileNumber}
                      invalid={mobileNumberError}
                      required={mobileNumberError}
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg={6} md={12} sm={12}>
                  <FormGroup className="position-relative">
                    <Label>
                      E-mail <span className="col-red">*</span>
                    </Label>
                    <Input
                      pattern={
                        fields?.email == ".+@gmail.com" ||
                        fields?.email == ".com"
                      }
                      type="email"
                      name="email"
                      value={email}
                      invalid={emailError}
                      required={emailError}
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg={12}>
                  <FormGroup className="position-relative">
                    <Label>
                      Password <span className="col-red">*</span>
                    </Label>
                    <Input
                      type="password"
                      name="password"
                      value={password}
                      invalid={passwordError}
                      required={passwordError}
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg={12}>
                  <FormGroup className="position-relative">
                    <Label>
                      Confirm Password <span className="col-red">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="confirm-password"
                      value={confirmpassword}
                      invalid={passwordError}
                      required={passwordError}
                      onChange={onChangeHandler}
                    />
                  </FormGroup>
                </Col>

                <ReCAPTCHA
                  sitekey={
                    settings?.googleCaptchaKey?.captchaKey ||
                    "6LfHhHgmAAAAAMDY7S-sxLljqfIE6ku1u1zYWNi2"
                  }
                  onChange={handleVerify}
                />
              </Row>
              {loading ? (
                <div className="loading_div">
                  <button className="loading_btn" type="submit">
                    <Spinner animation="border" role="status"></Spinner>
                  </button>
                </div>
              ) : (
                <div className="text-center Done-wrap">
                  <button
                    onClick={onSubmit}
                    className="showmore btn btn-primary Submit-btn"
                    type="submit"
                    // disabled={Termandcondition?.tnc == false}
                  >
                    Create Account
                  </button>
                </div>
              )}
            </Form>
          </div>
        </Container>
      </section> */}
        {OpenPrivado == true &&  <div className="barcodeBoxMaine barcodeafterlogin">
        <Privadoqr func={Privado} />
       
    </div> }
    </>
  );
}
